import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PosLoader() {
    const { t } = useTranslation();
    return (
        <div className="pos-loader-overlay">
            <div className="pos-loader-scene">
                <div className="pos-erp-panel">
                    <div className="pos-erp-header"></div>
                    <div className="pos-erp-lines"></div>
                </div>

                <div className="pos-transfer">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div className="pos-device">
                    <div className="pos-display"></div>
                    <div className="pos-keypad">
                        <div></div><div></div><div></div>
                        <div></div><div></div><div></div>
                        <div></div><div></div><div></div>
                    </div>
                    <div className="pos-receipt-slot"></div>
                </div>
            </div>
            <p className="pos-loader-label">{t("syncingWithPos")}</p>
        </div>
    );
}
